import axios from 'axios';
import { cachetime } from '../config';

export default function() {
  return {
    namespaced: true,
    state: {
      video_playlists: {},
      video_gallery: {},
    },
    mutations: {
      SET_VIDEO_PLAYLISTS(state, { data, locale }) {
        state.video_playlists[locale] = {
            data,
            __updatedAt: Date.now()
        }
      },
      SET_VIDEO_GALLERY(state, { data, locale }) {
        state.video_gallery[locale] = {
            data,
            __updatedAt: Date.now()
        }
      },
    },
    actions: {
      FETCH_VIDEO_PLAYLISTS({ state, commit }, { locale }) {
        const now = Date.now();
        if(state.video_playlists) {
            if(now - state.video_playlists.__updatedAt < cachetime) {
                return;
            }
        }
        
        return axios.get(encodeURI(`/api/video-playlists`))
          .then((res) => {
            const data = res.data || {};
            commit('SET_VIDEO_PLAYLISTS', { data, locale });
          }).catch(err => {
            console.log(err);
            throw err;
          });
      },
      FETCH_VIDEO_GALLERY({ state, commit }, { locale }) {
        const now = Date.now();
        if(state.video_gallery) {
            if(now - state.video_gallery.__updatedAt < cachetime) {
                return;
            }
        }
        
        return axios.get(encodeURI(`/api/videogallery`))
          .then((res) => {
            const data = res.data || {};
            commit('SET_VIDEO_GALLERY', { data, locale });
          }).catch(err => {
            console.log(err);
            throw err;
          });
      }
    },
    getters: {
      getVideoPlaylists: (state) => (locale) => {
        return state.video_playlists[locale];
      },
      getVideoGallery: (state) => (locale) => {
        return state.video_gallery[locale];
      },
    }
  }
}